import ReactCollapsible from 'react-collapsible';
import { Icon } from 'palette/Icon';
import { Small } from 'palette/Typography';

import '../styles/FooterAccordion.scss';

export function FooterAccordion({
    title,
    children
}) {
    const accordionHeader = (
        <>
            <Small
                color="strong"
                level="1"
                weight="bold"
            >
                {title}
            </Small>
            <Icon
                className="react-footer-accordion__icon"
                name="palette_chevron_down"
                size="x-small"
            />
        </>
    );

    return (
        <ReactCollapsible
            classParentString="react-footer-accordion"
            contentElementId={[title, 'content'].join('-')}
            easing="ease-in-out"
            openedClassName="react-footer-accordion--active"
            transitionTime={200}
            trigger={accordionHeader}
            triggerElementProps={{ id: title }}
        >
            <div className="react-footer-accordion__body">
                {children}
            </div>
        </ReactCollapsible>
    );
}
